import { computed } from 'vue';
import { SET_POPUP_MEDIA_CONTENT } from '#shared/types/actions';
import { isDevelopment } from '#shared/utils/isDevelopment';

export const usePopupLink = () => {
  const { hostlink } = useEnvProps();
  const navShared = useNavShared();

  const popupMediaContent = computed(() => navShared.popupMediaContent);
  const host = isDevelopment() ? '' : hostlink;

  // for AEM popup
  const popupLinkHandler = async (e) => {
    const elem = e.target?.closest('a[href*="popupOverlayId"]');
    if (elem) {
      e.preventDefault();
      try {
        const popupId = elem.href?.match(/popupOverlayId=(\d+)/)[1];
        const reqUrl = `${host}/shop/mediapopup?queryType=popup&popupID=${popupId}&isAEM=true&xapi=1`;

        const { data, error } = await useFetch(reqUrl);

        if (error.value) {
          // Throw the error to be caught by the catch block
          throw error.value;
        }

        if (data.value) {
          navShared[SET_POPUP_MEDIA_CONTENT](data.value.mediacontent);
        }
      } catch (err) {
        console.error('Failed to handle popup link:', err);
      }
    }

    return true;
  };

  return {
    popupMediaContent,
    popupLinkHandler,
  };
};

export default {};
